import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxMaskWrapperModule } from '../../shared/ngx-mask-wrapper.module';

import { MaterialModule } from '../material/material.module';
import { AddPaymentMethodDialogComponent } from './add-payment-method-dialog.component';

@NgModule({
    declarations: [AddPaymentMethodDialogComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        FormsModule,
        ReactiveFormsModule,
        NgxMaskWrapperModule
    ],
    exports: [AddPaymentMethodDialogComponent]
})
export class AddPaymentMethodDialogModule { }
